export const blockIconsHardwareSaveNew = (
	<span className='material-symbols-outlined'>save</span>
);
